<template>
    <v-tab-item class="fill-height">
        <v-layout column justify-center class="h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">

                <div class="text-center mb-20 mb-lg-40">
                    <h3 class="tit mb-8 mb-lg-16">계약 대상자 선택</h3>
                    <p class="page-text--lg grey-6--text">근로계약을 체결할 대상자를 선택해 주세요.</p>
                </div>

                <v-card rounded="lg" flat color="grey-f7" class="mb-20 mb-lg-40" style="overflow: unset;">
                    <div class="pa-20 pa-md-30 pa-lg-40">
                        <v-row align="center" class="row--small">
                            <v-col cols="12" md="auto" class="mb-10 mb-md-0">
                                <p class="page-text font-weight-medium min-w-md-100px min-w-lg-160px">채용공고 선택</p>
                            </v-col>
                            <v-col>
                                <v-row class="row--small">
                                    <v-col cols="12" sm="">
                                        <v-select 
                                            v-model="recruitmentId" 
                                            v-bind="attrs_input" 
                                            :items="items" 
                                            item-text="subject" 
                                            item-value="_id" 
                                            placeholder="채용공고를 선택해주세요" 
                                            @change="onChange"
                                            />  
                                    </v-col>
                                    <v-col cols="12" sm="auto">
                                        <router-link :to="`/recruitments/${recruitmentId}`" target="_blank"><v-btn color="primary" block>자세히 보기</v-btn></router-link>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <div class="v-cards" v-if="recruitmentId">
                    <employment-contract-item v-for="item in applications" :key="item?.id" :value="item" :recruitment="item.recruitment" :checkedApplicants="checkedApplicants"  @checkApplicant="getApplicants" /> 
                </div>

            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="cancle()"><span class="grey-6--text">취소</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save()"><span>저장하기</span></v-btn>
            </div>
            <!-- <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition> -->
        </v-layout>
    </v-tab-item>
</template>

<script>
import { attrs_input, } from "@/assets/variables";
import EmploymentContractItem from "@/components/dashboard/company/employment/contract/form/employment-contract-item.vue";
import api from '@/api';

export default {
    components: {
        EmploymentContractItem,
    },
    props: {
        value: { type: [String, Object, Array], default: null },
        applicants: { type: Array, default: () => [] }        //최종 선택 대상자
    },
    data: () => ({
        attrs_input,
        recruitmentId: null,            //공고 id
        items : [],                     //채용공고 list  
        applications:[],                //해당 공고 id 의 합격자 리스트
        checkedApplicants:[],           //선택된 지원자 리스트
        limit: 10,
        summary: { totalCount: 0 },
        sort : JSON.stringify({ appliedAt: -1 })
    }),
    mounted(){
        this.init()
    },
    watch:{
        applicants(){
            this.checkedApplicants = [];
            this.checkedApplicants.push(...this.applicants);
        }
    }
    ,
    methods:{
        async init(){
            try{
                var { recruitments } = await api.v1.company.recruitments.gets({_id: this.value?._id})
                this.items = recruitments;
                this.$nextTick(this.search);
            } catch(e){
                console.error(e)
            }
        },
        async search(){
            try{
                if(this.recruitmentId){
                    let { skip, limit, sort, params } = this;
                    const { summary, applications } = await api.v1.company.recruitments.applications.gets({
                        headers: { skip, limit, sort },
                        params: { stage:'ON_RECRUIT' },
                        _recruitment: this.recruitmentId,
                    });
                    this.summary = summary;
                    this.applications = applications;
                }
            }
            catch (e){
                console.error(e)
            }
        },
        onChange(value) {
            this.search();
            // this.$emit("input", value);
            // this.$nextTick(() => this.$emit("emit"));
        },
        getApplicants(value){
            if(value){
                let idx = this.checkedApplicants.map(e=>e._id).indexOf(value._id);
                if(idx<0){
                    this.checkedApplicants.push(value);
                } else{
                    this.checkedApplicants.splice(idx,1);
                }
            }
        },
        save(){
            this.cleanForm();
            this.$emit('checkedApplicants',this.checkedApplicants);
            this.$emit('main');
        },
        cancle(){
            this.cleanForm();
            this.checkedApplicants= [];
            this.checkedApplicants.push(...this.applicants);
            this.$emit('main');
        },
        cleanForm(){
            this.recruitmentId = null;
        }
    },
};
</script>